import { CoachExternalReviewSourcesEnum, CoachReviewTypesEnum } from 'types/generated/client';
import CourtFlat from 'svg/CourtFlat';
import GoogleIcon from 'svg/GoogleIcon';
import VideoCamera from 'svg/VideoCamera';
import Pill from 'components/Pill';
import { formatCreationWithIntl } from 'components/Premium/utils';
import SharedReviewCard from 'components/ReviewCard';
import { ReviewType } from '../types';

const PILL_BY_TYPE = {
  [CoachReviewTypesEnum.Remote]: {
    className: '!text-color-oncourt-text bg-color-oncourt-bg text-xs',
    text: 'Remote',
    icon: <VideoCamera className="h-3.5 w-3.5" />,
  },
  [CoachReviewTypesEnum.Court]: {
    className: '!text-color-remote-text bg-color-remote-bg text-xs',
    text: 'On-Court',
    icon: <CourtFlat className="h-3.5 w-3.5" />,
  },
};

/**
 * Adapter over the shared review card. Keeps its original signature so the coach
 * profile, the reviews modal and the court page all keep working unchanged; only
 * the coach-specific type pill and external source mark live here.
 */
const ReviewCard: React.FC<{ review: ReviewType; inModal?: boolean }> = ({
  review,
  inModal = false,
}) => {
  // `type` is a coaching modality, so it's null on a player review and the DB only
  // requires it for coach reviews.
  const typePill = review.type ? PILL_BY_TYPE[review.type as CoachReviewTypesEnum] : undefined;

  return (
    <SharedReviewCard
      name={review.reviewer?.fullName || review.externalFullName || ''}
      avatarPath={review.reviewer?.profileImagePath}
      avatarUrl={review.externalImageUrl}
      dateLabel={formatCreationWithIntl(review.createdAt, false)}
      rating={review.rating}
      review={review.review}
      inModal={inModal}
      badge={
        typePill && (
          <Pill
            text={typePill.text}
            className={typePill.className}
            icon={typePill.icon}
            size="sm"
          />
        )
      }
      sourceIcon={
        review.externalSource === CoachExternalReviewSourcesEnum.Google && (
          <GoogleIcon className="h-5 w-5" />
        )
      }
    />
  );
};

export default ReviewCard;
